module.exports = __webpack_public_path__ + "img/ks.445c8bba.png";